'use strict';

var importedFromBase = require('./searchImportedHelperFunctions');
var customSearchHelpers = require('./searchHelperFunctions');
var searchRefinements = require('./searchRefinements');
const searchMobile = require('./searchMobile');
const badges = require('../product/badges');

$(document).on('click', '.option-view', function(e) {
    e.preventDefault();

    var displayViewSelected = $(this).text();

    if(displayViewSelected !== sessionStorage.getItem('display-view-selected')) {
        $('.option-view').removeClass('active-option');
        $(this).addClass('active-option');

        sessionStorage.setItem('display-view-selected', displayViewSelected);

        let targetUrl = customSearchHelpers.getNewUrl();
        const targetUrlObj = new URL(targetUrl);
        targetUrlObj.searchParams.set('sz', displayViewSelected);
        targetUrlObj.searchParams.set('start', 0);

        localStorage.setItem('currentUrl', targetUrlObj);
        localStorage.setItem('currentPagePagination', 1);

        customSearchHelpers.updateSearchUrl(targetUrlObj.toString());
        customSearchHelpers.showByPage();
    } else {
        return;
    }
});

$('.container').on('click', '.product-grid', function (e) {
  let plpScrollPositionSavedRykValue = $(window).scrollTop();
  localStorage.setItem('plpScrollPositionSavedRyk', plpScrollPositionSavedRykValue);
});

$(document).on('click', '.page-link', function (e) {
    e.stopPropagation();
    e.preventDefault();

    if ($(this).hasClass('next') || $(this).hasClass('previous') || $(this).hasClass('dots') || $(this).hasClass('active')) {
        return;
    }
    var pageSelected = $(this).data('url');
    var selectedPageNumber = $(this).data('page-number');
    var currentPageNumber = customSearchHelpers.getCurrentPagePagination();

    if(selectedPageNumber && (selectedPageNumber !== Number(currentPageNumber))) {
        localStorage.setItem('currentUrl', pageSelected);
        customSearchHelpers.setCurrentPagePagination(selectedPageNumber);
        customSearchHelpers.showByPage({selectedUrl: pageSelected}, true);
        customSearchHelpers.updateSearchUrl(pageSelected);
    }

});

$(document).on('click', '.next', function(e) {
    customSearchHelpers.handlePreviousAndNext('next',e);
});

$(document).on('click', '.previous', function(e) {
    customSearchHelpers.handlePreviousAndNext('previous',e);
});

$(document).on('click', '.display-option', function (e) {
    e.preventDefault();
    var $this = $(this);
    customSearchHelpers.handleGridSize($this);
});

$(document).on('click', '.did-you-mean', function(e) {
    var url = $(this).attr('href');

    localStorage.setItem('params', url);
});

$(document).on('click', '.tabular-nav__item', function(e) {
    localStorage.setItem('currentPagePagination', 1);
});

document.addEventListener("visibilitychange", (event) => {
    event.preventDefault();

    var currentUrl = window.location.href;

    if (currentUrl.includes('?q=')) {
        currentUrl = window.location.href.split('&')[0];
    } else {
        currentUrl = window.location.href.split('?')[0];
    }

    if (document.visibilityState == "visible") {
        if (currentUrl !== localStorage.getItem('currentUrl')) {
            localStorage.setItem('currentUrl', currentUrl);
        }
    }
});

$(document).on('mouseenter', '.refinements .card', function(e) {
    e.preventDefault();
    customSearchHelpers.handleShowFilters(e);
})

$(document).on('mouseleave', '.refinements .card', function (e) {
    e.preventDefault();
    customSearchHelpers.handleShowFilters(e);
});

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var headerHeight = $(document).find('.ryk-header').innerHeight();
    if (!searchMobile.isMobile()) {
        if (scroll > 205) {
            $(document).find('.refinement-bar, .responsive-header-container').css('position', 'fixed');
            $(document).find('.refinement-bar, .responsive-header-container').css('top', headerHeight + 'px');
         } else if (scroll < 204) {
            $(document).find('.refinement-bar, .responsive-header-container').css('position', 'absolute');
            $(document).find('.refinement-bar, .responsive-header-container').css('top', 0);
         }
    }
});

$(window).on('load', function() {
    const scrollPositionSavedValue = localStorage.getItem('plpScrollPositionSavedRyk');

    let currentUrl = window.location.href;

    if(!localStorage.getItem('currentUrl') || (currentUrl !== localStorage.getItem('currentUrl'))) {
        localStorage.setItem('currentUrl', currentUrl);
        customSearchHelpers.setCurrentPagePagination(1);
        sessionStorage.setItem('display-view-selected', '24');
    }

    if (!$(document).find('.total-products-count').text().includes('ningun resultado')) {
        customSearchHelpers.showByPage();
    }

    if (scrollPositionSavedValue && scrollPositionSavedValue.length < 1) {
      customSearchHelpers.scrollToBegin();
    }


    badges.plpStructureOldBadges();
    searchRefinements.setMaxValue();
    $('.close-section-filter-mobile').attr('data-href',currentUrl);
});


module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(document).on('click', 'button.filter-results, .filter-results', function () {
            $('.refinement-bar').removeAttr('style');
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar, .modal-background').modal({backdrop: 'static',keyboard: false});
            $('body').addClass('modal-open');
            $('.modal-backdrop').remove();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            searchMobile.cloneBtnFilters('.filter-bar','.btn-filters-cloned');
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', ' button.close,div.close-section-filter-mobile , div.close-section-filter-mobile-container, .modal-background', function () {
            $('.refinements-bar').attr('style', 'display: none');
            $('.refinement-bar, .modal-background').hide();
            $('body').removeClass('modal-open');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document).on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            $.spinner().start();

            const targetUrl = new URL(this.value);
            targetUrl.searchParams.set('sz', customSearchHelpers.getCurrentViewQuantity());

            customSearchHelpers.updateSearchUrl(targetUrl.toString());

            $(this).trigger('search:sort', this.value);

            localStorage.setItem('currentPagePagination', 1);
            localStorage.setItem('currentUrl', window.location.href);

            $.ajax({
                url: targetUrl,
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    customSearchHelpers.getSelectedDisplayOption();
                    customSearchHelpers.getQuantityDisplayedOption();
                    customSearchHelpers.createPaginationUrl();
                    customSearchHelpers.setCurrentPageActiveStyles();
                    badges.plpStructureOldBadges();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    importedFromBase.updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        window.addEventListener('popstate', function (e) { location.reload(); });

        // Handle refinement value selection and reset click
        const refinementSelectors = '.refinements li button, button.reset, .filter-value button, .swatch-filter button, button.apply-filters-just-mobile, .close-section-filter-mobile, div.close-section-filter-mobile-container';
        $('body').on('click', refinementSelectors, function (e) {
            e.preventDefault();

            const $this = $(this);
            const isCloseBtn = $this.hasClass('close-section-filter-mobile');

            if (searchMobile.isMobile() && !isCloseBtn) {    
                $('.refinement-bar').spinner().start();
            } else {
                $.spinner().start();
            }
            
            let actionToDo = searchMobile.ShouldApplyfilter($this);
            if ($(this).data('url') ) {
                customSearchHelpers.updateUrl($(this).data('url'));
            }

            var min = $('[data-min-input-price]').val();
            var max = $('[data-max-input-price]').val();
            var isReset = $(this).attr('class');
            var attributeId = '#' + $(this).find('span').last().attr('id');
            
            $(this).trigger('search:filter', e);

            let targetUrl = $(this).attr('data-href');
            targetUrl += targetUrl.includes('?') ? '&sz=' : '?sz=';
            targetUrl += customSearchHelpers.getCurrentViewQuantity();

            customSearchHelpers.setCurrentPagePagination(1);

            $.ajax({
                url: targetUrl,
                method: 'GET',
                success: function (response) {
                    $(document).trigger('search:mobile', {
                        response : response,
                        actionToDo : actionToDo,
                        $this : $this
                    });
                    $(attributeId).parent('button').focus();
                    customSearchHelpers.getSelectedDisplayOption();
                    customSearchHelpers.getQuantityDisplayedOption();
                    customSearchHelpers.setCurrentPageActiveStyles();
                    searchRefinements.displayActualPriceFilter(min, max, isReset);
                    customSearchHelpers.handleActiveFilters();
                    searchRefinements.setMaxValue();
                    $(document).trigger('search:afterUpdateDom', $this);
                    badges.plpStructureOldBadges();
                    $.spinner().stop();
                },
                error: function () {
                    $(attributeId).parent('button').focus();
                    $.spinner().stop();
                }
            });
        });
    },
    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                importedFromBase.getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            importedFromBase.getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
    handleStickyHeader: function () {
        var observer = null;

        function initObserver() {
            if (observer) {
                observer.disconnect();
            }

            var observerElement = document.querySelector('.grid-header .container-mobile-sort-by');
            var stickyElement = document.querySelector('.sticky.container-mobile-sort-by');

            if (observerElement && stickyElement) {
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting) {
                            $(stickyElement).removeClass('d-none');
                            $(stickyElement).addClass('d-flex');
                        } else {
                            $(stickyElement).addClass('d-none');
                            $(stickyElement).removeClass('d-flex');
                        }
                    });
                }, {
                    threshold: [0, 1],
                    rootMargin: '-110px 0px 0px 0px'
                });

                observer.observe(observerElement);
            }
        }

        initObserver();

        $(document).on('search:afterUpdateDom', function () {
            if(observer) {
                observer.disconnect();
            }

            const $headerContainer = $(document).find('.grid-header .responsive-header-container');
            const $stickyHeaderContainer = $(document).find('.sticky.responsive-header-container');

            //sync sticky container
            $stickyHeaderContainer.html($headerContainer.html());

            initObserver();
        });
    }
};

